import React, { useState, useEffect, useCallback } from 'react'
import { SizeMe } from 'react-sizeme'
import isTextEllipsisShown from './utils/isTextEllipsisShown'
import Tooltip from './uiComponents/Tooltip/Tooltip'


const RadioSelection = (props) => {
  const { schema, value, uiSchema, readonly, onChange } = props

  const [listData, setListData] = useState([])
  const [selected, setSelected] = useState('')
  const [type, setType] = useState('')
  const [tooltipTarget, setTooltipTarget] = useState(null)
  const [height, setHeight] = useState('')

  useEffect(() => { setSelected(value) }, [value])

  useEffect(() => {
    const isRadioButtonList = uiSchema['ui:widgetSubType'] !== 'radioButtonList'

    const data = schema?.enum?.map((value, index) => {
      const radioButtonListOptions = isRadioButtonList ? {
        description: schema.enumDescriptions ? schema.enumDescriptions[index] : '',
        image: schema.icons ? schema.icons[index] : ''
      } : {}

      return {
        value: value,
        name: schema.enumNames[index],
        ...radioButtonListOptions
      }
    })

    setListData(data)
    setSelected(value)
    setType(uiSchema['ui:widgetSubType'])
  }, [schema])

  const handleSelect = (e) => {
    const selectedValue = e.currentTarget.dataset.value
    setSelected(selectedValue)
    onChange(selectedValue)
  }

  const keyPress = (e) => {
    if(e.key === 'Enter' || e.keyCode === 13) {
      handleSelect(e)
    }
  }

  const hideTooltip = () => () => {
    setTooltipTarget(null)
  }

  const showTooltip = (itemID, itemName, className) => () => {
    setTooltipTarget({
      id: itemID,
      name: itemName,
      className
    })
  }

  const ellipsisIsShown = () => {
    return tooltipTarget && isTextEllipsisShown(
      `.gallery-item .${tooltipTarget.className}[data-valuetooltip='${tooltipTarget.id}']`
    )
  }

  const getFinalSize = useCallback((heights, listData) => {
    let height
    if(listData.length === heights.length) {
      height = Math.max(...heights)
      setHeight(height)
    }
  }, [])

  const includesImage = listData?.some((item) => item.image)

  let heights = []
  return (
    <div id='test-id' className={`${type}_wrapper radio-selection-duc ${readonly ? 'disabled' : ''}`}>
      {
        listData?.length > 0 && listData?.map((item, index) => {
          const itemValue = item.value.replaceAll(/[`'"/\\]+/g, '')
          return (
            <SizeMe
              monitorHeight
              noPlaceholder
              key={`${item.name}_${index}`}
            >
              {({ size }) => {
                if(size.height && size.height > 0) {
                  heights = heights.concat(size.height)
                  getFinalSize(heights, listData)
                }
                return (
                  <div
                    className={`gallery-item ${type} ${item.value === selected ? 'selected' : ''}`}
                    tabIndex={readonly ? '' : 0}
                    style={{minHeight: height}}
                    data-value={item.value}
                    onClick={!readonly && handleSelect || null}
                    onKeyPress={!readonly && keyPress}
                    data-xmpie-focusable="true"
                  >
                    {type !== 'radioButtonList' && includesImage &&
                    <div className='imageRadio'>
                      {item.image && <img alt='' className='image'  src={item.image} />}
                    </div>
                    }
                    <div className='content'>
                        <span
                          className='name'
                          id={item.value}
                          data-valuetooltip={`tool_${itemValue}`}
                          onMouseLeave={hideTooltip()}
                          onMouseEnter={showTooltip(`tool_${itemValue}`, item.name, 'name')}
                        >
                          {item.name}
                        </span>
                      <span
                        className='description'
                        id={item.value}
                        data-valuetooltip={`tool_${itemValue}`}
                        onMouseLeave={hideTooltip()}
                        onMouseEnter={showTooltip(`tool_${itemValue}`, item.description, 'description')}
                      >
                          {item.description}
                        </span>
                      {
                        tooltipTarget && ellipsisIsShown()
                        && <Tooltip
                          isOpen
                          hideArrow
                          placement='bottom-end'
                          text={tooltipTarget.name}
                          target={document.querySelector(`.gallery-item .${tooltipTarget.className}[data-valuetooltip='${tooltipTarget.id}']`)}
                        />
                      }
                    </div>
                  </div>
                )
              }}
            </SizeMe>
          )
        })
      }
    </div>
  )
}

if (typeof window !== 'undefined') {
  window.uStoreDucs = window.uStoreDucs || []
  window.uStoreDucs.push({ name: 'radioButtonList', component: RadioSelection, displayNames: ['Gallery Grid View', 'Gallery List View', 'Radio Button List'] })
}

export default RadioSelection
